export default __webpack_public_path__ + "static/media/paperInProgress.78d06170.svg";